import { Link } from '@tanstack/react-router';

import Button from '../Button/Button';

const NotFound = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 py-24 text-center">
      <p className="text-[10rem] leading-none font-black tracking-tighter text-amber-900/20 select-none sm:text-[14rem]">
        404
      </p>
      <h1 className="-mt-6 text-3xl font-bold tracking-tight text-gray-900 sm:-mt-10">
        Page introuvable
      </h1>
      <p className="mt-4 text-lg leading-7 text-gray-600">
        Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <div className="mt-10 flex items-center gap-x-4">
        <Link to="/">
          <Button size="lg">Retour à l'accueil</Button>
        </Link>
        <Link to="/rendez-vous">
          <Button size="lg" color="secondary">
            Prendre rendez-vous
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
